import images from './images';

export const consts = {
  stripe_pk: 'pk_test_EUVUOXizQ732gKUz2eC5S0KC00Towly9B9',
};

export default {
  images,
};
